/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="95.58"
        height="78.94"
        viewBox="0 0 95.58 78.94"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          fill="#ffb81c"
          d="M47.78 17.4a8.37 8.37 0 1 0 8.36 8.38 8.36 8.36 0 0 0-8.35-8.37Zm0 2.5a5.87 5.87 0 1 1-5.86 5.88 5.87 5.87 0 0 1 5.85-5.87Z"
          className="icon-fill icon-accent"/>
        <path
          fill="#ffb81c"
          d="M53.49 62.56a3.21 3.21 0 1 0-3.21 3.21 3.2 3.2 0 0 0 3.21-3.21"
          className="icon-fill icon-accent"
          fillRule="evenodd"/>
        <path
          fill="#fff"
          d="M81.49 3a1.26 1.26 0 0 1 1.24 1.13V77.7a1.22 1.22 0 0 1-1.12 1.24H14.1a1.24 1.24 0 0 1-1.24-1.12V24.76a1.26 1.26 0 0 1 1.28-1.22 1.24 1.24 0 0 1 1.21 1.09v51.82h64.88v-71H69.82v9.82a1.25 1.25 0 0 1-1.12 1.25h-.13a1.25 1.25 0 0 1-1.24-1.12V4.2A1.27 1.27 0 0 1 68.49 3Z"
          className="icon-fill icon-base"/>
        <path
          fill="#fff"
          d="M47.07.22a1.25 1.25 0 0 1 1.29-.07l.12.07 46.51 31.87a1.25 1.25 0 0 1 .34 1.73 1.25 1.25 0 0 1-1.63.4l-.11-.07L47.76 2.76 1.99 34.15a1.25 1.25 0 0 1-1.66-.22l-.08-.11a1.25 1.25 0 0 1 .22-1.65l.1-.08ZM35.49 59.1c0-17 24-17.16 24.51-.51v19h-2.51V59.1c0-13.69-19.13-13.82-19.51-.41v18.94h-2.49Z"
          className="icon-fill icon-base"/>
      </svg>

    );
  }
}

Icon.displayName = 'HouseIcon';

export default Icon;
